export default __webpack_public_path__ + "static/media/boxUnknown2.984378eb.png";